module.exports = __webpack_public_path__ + "comments/production/img/avatar_male.5e7f4fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_male.jpg
// module id = HsMM
// module chunks = 0